import {
  Component,
  Input,
  OnInit, AfterViewInit,
  ViewChildren,
  QueryList,
  ElementRef,
  ViewChild
} from '@angular/core';

import {
  ControlValueAccessor,
  FormControl,
  Validator,
  NgForm,
  NgModelGroup
} from '@angular/forms';
import { UuidService } from '../../../global/uuid.service';
import { CONFIG } from '../input.config';

@Component({
  template: ''
})
export class InputBaseComponent implements ControlValueAccessor, Validator, OnInit, AfterViewInit {
  protected _value: any = '';

  protected _errorMessages = CONFIG.errorMessages;

  @Input()
  public groupClass: string;

  @Input()
  public id: string;

  @Input()
  public name: string;

  @Input()
  public rules: { [s: string]: any };

  @Input()
  public required: any;

  @Input()
  public placeholder: any;

  @Input()
  public disabled: any;

  @Input()
  public form: NgForm;

  @Input()
  public group: NgModelGroup;

  @Input()
  public errorOrdering: string[] = CONFIG.errorOrdering;

  @Input()
  public submitted: boolean;

  @Input()
  public autocomplete: string;

  @Input()
  public showErrors: boolean = true;
  
  @Input()
  public showWithoutFormSubmit: boolean = false;

  @ViewChild('labelElement')
  public labelElement: ElementRef;

  public hasLabel: boolean = true;

  public isFocused: boolean = false;
  public isActive: boolean = false;

  // the method set in registerOnChange to emit changes back to the form
  protected propagateChange = (_: any) => {
    return;
  }

  constructor(protected uuidService: UuidService) {
  }

  @Input()
  public set errorMessages(values) {
    this._errorMessages = Object.assign({}, this._errorMessages, values || {});
  }

  public get errorMessages() {
    return this._errorMessages;
  }

  get value() {
    return this._value;
  }

  set value(val) {
    this._value = val;

    this.propagateChange(val);
  }

  public ngOnInit() {
    if (!this.id) {
      this.id = this.uuidService.factory('').toString();
    }
  }

  public ngAfterViewInit() {
    setTimeout(() => {
      if (this.labelElement) {
        this.hasLabel = !!this.labelElement.nativeElement.innerHTML.replace(/\s/g, '').length;
      } else {
        this.hasLabel = false;
      }
    }, 0);
  }

  // this is the initial value set to the component
  public writeValue(value: any) {
    if (value) {
      this._value = value;
    }

    if (this._value) {
      this.isActive = true;
    }
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  // validates the form, returns null when valid else the validation object
  public validate(c: FormControl) {
    return null;
  }

  // not used, used for touch input
  public registerOnTouched() {
    return;
  }

  // change events from the text field
  protected onChange(event) {
    this.value = event.target.value;
  }

  public handleFocus() {
    this.isFocused = true;
    this.isActive = true;
  }

  public handleBlur() {
    this.isFocused = false;
    this.isActive = !!this.value.length;
  }

  public handleChange() {
    this.isActive = !!this.value.length;
  }

  public isSubmitted() {
    if (typeof (this.submitted) !== 'undefined') {
      return this.submitted;
    } else if (this.form) {
      return this.form.submitted;
    } else {
      return false;
    }
  }

  public hasErrors() {
    if (this.group) {
      return this.group.invalid &&
        this.group.touched &&
        this.group.control.controls[this.name] &&
        !this.group.control.controls[this.name].valid &&
        (!this.form || this.form.submitted);
    } else if (this.form) {
      if (this.showWithoutFormSubmit && !this.isFocused && this.form.controls[this.name] && this.form.controls[this.name].dirty) {
        return this.form && this.form.controls[this.name] && !this.form.controls[this.name].valid;
      }
      
      return this.form && this.form.controls[this.name] && !this.form.controls[this.name].valid && this.isSubmitted();
    }
  }

  public getErrorMessage() {
    const errors = this.group ? this.group.control.controls[this.name].errors : this.form.controls[this.name].errors;

    let errorMessage = null;

    if (errors) {
      for (const errorKey of this.errorOrdering) {
        if (errors[errorKey]) {
          errorMessage = this._errorMessages[errorKey];
          break;
        }
      }

      if (!errorMessage) {
        for (const errorKey in errors) {
          if (errors.hasOwnProperty(errorKey) && this.errorOrdering.indexOf(errorKey) === -1) {
            errorMessage = this._errorMessages[errorKey];
            break;
          }
        }
      }
    }

    return errorMessage;
  }
}


// WEBPACK FOOTER //
// ./src/app/form/input/base/base.component.ts